
      var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHeaderBackground = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 2026,
  height: 447,
  viewBox: "0 0 2026 447",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#header-background_3a58189d064231ab__a)"
}, /*#__PURE__*/React.createElement("path", {
  transform: "translate(0 .49)",
  fill: "url(#header-background_3a58189d064231ab__b)",
  d: "M0 0h2025.4v446.221H0z"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#header-background_3a58189d064231ab__c)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 1014.76,
  cy: 1698.49,
  rx: 1976.79,
  ry: 1502.85,
  fill: "#fff"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "header-background_3a58189d064231ab__b",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "matrix(0 534.986 -2428.3 0 1015.4 368.253)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "var(--theme-light,#e2cff6)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "var(--theme-bright,#c5a0ef)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "header-background_3a58189d064231ab__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(0 .49)",
  d: "M0 0h2025.4v446.221H0z"
})), /*#__PURE__*/React.createElement("filter", {
  id: "header-background_3a58189d064231ab__c",
  x: -1133.38,
  y: 44.551,
  width: 4296.28,
  height: 3348.39,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 20.254
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 85.674
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.77795 0 0 0 0 0.627992 0 0 0 0 0.848519 0 0 0 0.45 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_7711_43506"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_7711_43506",
  result: "shape"
})))));

      const __svgRaw = "<svg width=\"2026\" height=\"447\" viewBox=\"0 0 2026 447\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <g clip-path=\"url(#pzxsivdm8a)\">\r\n        <path transform=\"translate(0 .49)\" fill=\"url(#etsk4rtf9b)\" d=\"M0 0h2025.4v446.221H0z\"/>\r\n        <g filter=\"url(#f2qu3bjlyc)\">\r\n            <ellipse cx=\"1014.76\" cy=\"1698.49\" rx=\"1976.79\" ry=\"1502.85\" fill=\"#fff\"/>\r\n        </g>\r\n    </g>\r\n    <defs>\r\n        <radialGradient id=\"etsk4rtf9b\" cx=\"0\" cy=\"0\" r=\"1\" gradientUnits=\"userSpaceOnUse\" gradientTransform=\"matrix(0 534.986 -2428.3 0 1015.4 368.253)\">\r\n            <stop stop-color=\"var(--theme-light,#e2cff6)\"/>\r\n            <stop offset=\"1\" stop-color=\"var(--theme-bright,#c5a0ef)\"/>\r\n        </radialGradient>\r\n        <clipPath id=\"pzxsivdm8a\">\r\n            <path fill=\"#fff\" transform=\"translate(0 .49)\" d=\"M0 0h2025.4v446.221H0z\"/>\r\n        </clipPath>\r\n        <filter id=\"f2qu3bjlyc\" x=\"-1133.38\" y=\"44.551\" width=\"4296.28\" height=\"3348.39\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\r\n            <feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\r\n            <feColorMatrix in=\"SourceAlpha\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\r\n            <feOffset dy=\"20.254\"/>\r\n            <feGaussianBlur stdDeviation=\"85.674\"/>\r\n            <feComposite in2=\"hardAlpha\" operator=\"out\"/>\r\n            <feColorMatrix values=\"0 0 0 0 0.77795 0 0 0 0 0.627992 0 0 0 0 0.848519 0 0 0 0.45 0\"/>\r\n            <feBlend in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_7711_43506\"/>\r\n            <feBlend in=\"SourceGraphic\" in2=\"effect1_dropShadow_7711_43506\" result=\"shape\"/>\r\n        </filter>\r\n    </defs>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/header-background.3a58189d064231ab2cfa63e31b5b3d1f.svg"),
        {
          React: SvgHeaderBackground,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      